import { FormControlLabel, Switch, Typography } from "@material-ui/core";
import React from "react";

class FormCheckbox extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange = (event, value) => {
    if (this.props.input.onChange && !this.props.readOnly) {
      this.props.input.onChange(event);
      this.props.input.onBlur(event);

      if (this.props.onToggle) {
        this.props.onToggle(value);
      }
    }
  };

  render() {
    let lValue = this.props.input.value;

    if (!lValue) {
      lValue = false;
    }

    let lLabel = "Yes";

    if (!lValue) {
      lLabel = "No";
    }

    return (
      <div>
        {this.props.label ? <Typography variant="caption">{this.props.label}</Typography> :null}
        <FormControlLabel
          control={<Switch checked={lValue} onChange={this.handleChange} />}
          label={lLabel}
        />
      </div>
    );
  }
}

export default FormCheckbox;



// WEBPACK FOOTER //
// ./src/components/Wrappers/materialUIWrappers/components/FormCheckbox.jsx